import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';

@Component({
    selector: 'tt-poh-top-op',
    templateUrl: './poh-top-op.component.html',
    styleUrls: ['./poh-top-op.component.css'],
    standalone: false,
})
export class PohTopOpComponent implements OnInit {
    @Input()
    public params?: GetPohTopOpParams;

    public page?: PohTopOpGet;

    public grid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadPage() {
        if (!!this.params) {
            this.page = (await this.datatask.Post(1924, this.params))[0];
        }
    }

    private loadGrid() {
        if (!this.page) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.page.view_id)
                .setLoadDataFunction({
                    method: this.page.p2_datatask_keyno as number,
                    parameters: { poh_keyno_top: this.page.poh_keyno_top }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadPage();
        this.loadGrid();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}

interface GetPohTopOpParams {
    poh_keyno_top: string;
}

interface PohTopOpGet {
    page_heading: string;
    poh_keyno_top: string;
    view_id: string;
    p2_datatask_keyno: string | number;
}
